document.addEventListener("DOMContentLoaded", function(event) {
    pageLoaded();
    
    setOffsetMp();
    // menuAgil();
    collapseRedirectMp1();
    collapseRedirectMp2();
});


// WP AND BODY OFFSET WITH MENU PRINCIPAL FIXED TOP
const wpAdminBar = document.querySelector('#wpadminbar') || 0;
const headerFixed = document.querySelector('header.fixed-top');
const bodyTemplate = document.querySelector('body');

bodyTemplate.classList.add('stop-scrolling');

const pageLoaded = () =>{
    setTimeout(() => {
        let loaderSection = document.querySelector('.load-content');
        loaderSection.classList.add('loaded');
        bodyTemplate.classList.remove('stop-scrolling');
    }, 1000);
    // }, 0);
}

const setOffsetMp = () => {
    if(window.innerWidth > 600){
        if(wpAdminBar && window.scrollY < headerFixed.offsetHeight){
            headerFixed.setAttribute('style',`top: ${wpAdminBar.offsetHeight}px`);
            // bodyTemplate.setAttribute('style',`margin-top: ${headerFixed.offsetHeight}px`);
        }
        else{
            headerFixed.setAttribute('style',`top: ${wpAdminBar.offsetHeight}px`);
            // bodyTemplate.setAttribute('style',`margin-top: ${headerFixed.offsetHeight}px`);
        }
    }
    else{
        if(wpAdminBar && window.scrollY < headerFixed.offsetHeight){
            headerFixed.setAttribute('style',`top: ${wpAdminBar.offsetHeight}px`);
            // bodyTemplate.setAttribute('style',`margin-top: ${headerFixed.offsetHeight}px`);
        }
        else{
            headerFixed.setAttribute('style',`top: 0px`);
            // bodyTemplate.setAttribute('style',`margin-top: ${headerFixed.offsetHeight}px`);
        }
    }
}

window.addEventListener('scroll', () => {
    setOffsetMp();

    if(window.innerWidth > 991){
        collapseInstMp1.hide();
        collapseInstMp2.hide();
    }
});

window.addEventListener('resize', () => {
    setOffsetMp();
    collapseRedirectMp1();
    collapseRedirectMp2();
});


// MENU PRINCIPAL SCRIPTING
const menuPrincipal = document.querySelector('#menuPrincipal');
const iconMenu = document.querySelector('#icon-menu');

// COLLAPSE MENU PRINCIPAL
const collapseMp1 = document.querySelector('#collapseMp1');
const collapseMp2 = document.querySelector('#collapseMp2');

// CUSTOM BTN
const btnCollapseMp1 = document.querySelector('#btnCollapseMp1');
// const btnCollapseMp2 = document.querySelector('#btnCollapseMp2');

const btnCollapseIconMp1 = document.querySelector('#btnCollapseMp1 span i');
const btnCollapseIconMp2 = document.querySelector('#btnCollapseMp2 span i');


// INSTANCIAS MENU PRINCIPAL
const collapseInstMp1 = new bootstrap.Collapse('#collapseMp1', {
    toggle: false,
    show: false,
    hide: false
});
const collapseInstMp2 = new bootstrap.Collapse('#collapseMp2', {
    toggle: false,
    show: false,
    hide: false
});

// CERRAR MENU ICON
const iconCerrarMenu = () => {
    iconMenu.classList.remove('icon-menu');
    iconMenu.classList.add('icon-cross');
}

// MOSTRAR MENU ICON
const iconMostrarMenu = () => {
    iconMenu.classList.remove('icon-cross');
    iconMenu.classList.add('icon-menu');
}

// MENU PRINCIPAL EVENTOS
menuPrincipal.addEventListener('show.bs.collapse', (event) => {
    if(event.target.id === menuPrincipal.id){
        iconCerrarMenu();

        bodyTemplate.classList.add('stop-scrolling');
    }
    else{
        return false;
    }
});
menuPrincipal.addEventListener('hide.bs.collapse', (event) => {
    if(event.target.id === menuPrincipal.id){
        iconMostrarMenu();

        bodyTemplate.classList.remove('stop-scrolling');
    }
    else{
        return false;
    }
});

menuPrincipal.addEventListener('hidden.bs.collapse', (event) => {
    // console.log(event);
    if(event.target.id === menuPrincipal.id){
        btnCollapseMp1.classList.remove('active');
        btnCollapseMp2.classList.remove('active');

        btnCollapseIconMp1.classList.remove('icon-arrow-up');
        btnCollapseIconMp1.classList.add('icon-arrow-down');

        btnCollapseIconMp2.classList.remove('icon-arrow-up');
        btnCollapseIconMp2.classList.add('icon-arrow-down');

        collapseInstMp1.hide();
        collapseInstMp2.hide();
    }
    else{
        return false;
    }
});


// COLLAPSE CURSOS REDIRECT
const collapseRedirectMp1 = () => {
    if(window.innerWidth > 991){
            btnCollapseMp1.addEventListener('click', () =>{
            // location.href = "https://www.asd.com/cursos/";
            // location.href = "/productos/";
        });
    }
    // else{
    //         btnCollapseMp1.addEventListener('click', () =>{
    //         location.href = "#";
    //     });
    // }
}

// COLLAPSE TALLERES REDIRECT
const collapseRedirectMp2 = () => {
    if(window.innerWidth > 991){
            btnCollapseMp1.addEventListener('click', () =>{
            // location.href = "https://www.asd.com/talleres/";
            // location.href = "/productos/";
        });
    }
    // else{
    //         btnCollapseMp1.addEventListener('click', () =>{
    //         location.href = "#";
    //     });
    // }
}

// COLLAPSE MENU PRINCIPAL TRANSICIONES
collapseMp1.addEventListener('show.bs.collapse', (event) => {
    if(event.target.id === collapseMp1.id){
        btnCollapseMp2.classList.remove('active');
        btnCollapseMp1.classList.add('active');

        btnCollapseIconMp1.classList.remove('icon-arrow-down');
        btnCollapseIconMp1.classList.add('icon-arrow-up');

        collapseInstMp2.hide();
    }
    else{
        return false;
    }
});
collapseMp1.addEventListener('hide.bs.collapse', (event) => {
    if(event.target.id === collapseMp1.id){
        btnCollapseMp1.classList.remove('active');

        btnCollapseIconMp1.classList.remove('icon-arrow-up');
        btnCollapseIconMp1.classList.add('icon-arrow-down');
    }
    else{
        return false;
    }
});

collapseMp2.addEventListener('show.bs.collapse', (event) => {
    if(event.target.id === collapseMp2.id){
        btnCollapseMp1.classList.remove('active');
        btnCollapseMp2.classList.add('active');

        btnCollapseIconMp2.classList.remove('icon-arrow-down');
        btnCollapseIconMp2.classList.add('icon-arrow-up');

        collapseInstMp1.hide();
    }
    else{
        return false;
    }
});
collapseMp2.addEventListener('hide.bs.collapse', (event) => {
    if(event.target.id === collapseMp2.id){
        btnCollapseMp2.classList.remove('active');

        btnCollapseIconMp2.classList.remove('icon-arrow-up');
        btnCollapseIconMp2.classList.add('icon-arrow-down');
    }
    else{
        return false;
    }
});

// MOUSEOVER AND MOUSELEAVE COLLAPSE TRANSITIONS
btnCollapseMp1.addEventListener('mouseover', () => {
    collapseInstMp2.hide();
    collapseInstMp1.show();
});
btnCollapseMp1.parentElement.addEventListener('mouseleave', () => {
    collapseInstMp1.hide();
});

btnCollapseMp2.addEventListener('mouseover', () => {
    collapseInstMp1.hide();
    collapseInstMp2.show();
});
btnCollapseMp2.parentElement.addEventListener('mouseleave', () => {
    collapseInstMp2.hide();
});

// MENU AGIL
// const menuAgil = () => {
//     const btnMenuAgil = document.querySelector('#btn-menu-agil');
//     const collapseMenuAgil = document.querySelector('#collapseMenuAgil');

//     collapseMenuAgil.addEventListener('show.bs.collapse', () => {
//         btnMenuAgil.classList.add('d-none');
//     });

//     collapseMenuAgil.addEventListener('hide.bs.collapse', () => {
//         btnMenuAgil.classList.remove('d-none');
//     });
// }


